export default "__VITE_ASSET__BBOsXw5B__"